import { auth0CanActivate } from 'src/util/auth0/auth0.guard';
import { EVServiceType } from 'src/util/auth0/models/evServiceType.enum';
import { CommercialMapComponent } from './commercial-map/commercial-map.component';
import { COMMERCIAL_MAP_ROUTES } from './commercial-map/commercial-map.routes';
import { EstateMapComponent } from './estate-map/estate-map.component';
import { ESTATE_MAP_ROUTES } from './estate-map/estate-map.routes';
import { NEW_DWELLINGS_MAP_ROUTES } from './new-dwellings-map/new-dwelings-map.routes';
import { NewDwellingsMapComponent } from './new-dwellings-map/new-dwellings-map.component';
import { NewDwellingSalesDataService } from 'src/services/new-dwellings/new-dwelling-sales-data.service';
import { NewDwellingSalesStateService } from 'src/services/new-dwellings/new-dwelling-sales-state.service';
import { NewDwellingMapComponentsService } from 'src/services/new-dwellings/new-dwelling-map-components.service';
import { NewDwellingDataService } from '../infopage/services/new-dwelling-data.service';
import { EstateMapComponentsService } from 'src/services/estate/estate-map-components.service';
import { EstateSaleItemHoverService } from 'src/services/estate/estate-sale-item-hover.service';
import { FavoriteListExportService } from 'src/services/estate/favorite-list-export.service';
import { DistanceLineService } from 'src/services/map/distance-line.service';
import { CommercialMapComponentsService } from 'src/services/commercial/commercial-map-components.service';
import { CommercialSalesDataService } from 'src/services/commercial/commercial-sales-data.service';

export const EV_MAP_ROUTES = [
    {
        path: 'estate',
        providers: [EstateMapComponentsService, EstateSaleItemHoverService, FavoriteListExportService, DistanceLineService],
        component: EstateMapComponent,
        children: ESTATE_MAP_ROUTES,
        canActivate: [auth0CanActivate],
        // data: { routePermissions: [EVServiceType.Internal_Debug] }, //Todo: remove entirely when all is good in 5.0
    },
    {
        path: 'commercial',
        providers: [CommercialMapComponentsService, CommercialSalesDataService],
        component: CommercialMapComponent,
        children: COMMERCIAL_MAP_ROUTES,
        canActivate: [auth0CanActivate],
        data: { routePermissions: [EVServiceType.EvWeb_Commercial] },
    },
    {
        path: 'new-dwellings',
        providers: [NewDwellingSalesDataService, NewDwellingSalesStateService, NewDwellingMapComponentsService, NewDwellingDataService],
        component: NewDwellingsMapComponent,
        children: NEW_DWELLINGS_MAP_ROUTES,
        canActivate: [auth0CanActivate],
        data: { routePermissions: [EVServiceType.EvWeb_NewDwellings] }, //todo: change this to new-dwellings
    },
];
